import { CircularProgress } from '@mui/material';
import './ConfirmationDialog.scss'
import { DialougeSvg } from './svgs/Svgs'

export type ConfirmationType = 'discard' | 'delete' | 'update' | "cancel" | "book" | "warning";

interface ConfirmationDialogProps {
    type: ConfirmationType;
    open: boolean;
    title: string;
    loading?: boolean;
    description: string | React.ReactNode;
    onConfirm: () => void;
    onCancel: () => void;
    onDiscard?: () => void;
    confirm_button_text: string;
    cancel_button_text?: string;
    confirm_loading_text?: string;
    dataTestIdPrefix?: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ type, open, title, loading, description, onConfirm, onCancel, confirm_button_text, onDiscard, cancel_button_text, confirm_loading_text, dataTestIdPrefix }) => {

    const getUpdatedButtonText = () => {
        if (confirm_loading_text) {
            return confirm_loading_text;
        }
        switch (type) {
            case 'delete':
                return 'Deleting'
            case 'update':
                return 'Updating'
            case 'cancel':
                return 'Canceling'
            case 'discard':
                return 'Discarding'
            case 'book':
                return 'Booking'
            case 'warning':
                return 'Confirming'
            default:
                return 'Confirm'
        }
    }

    const buttonText = getUpdatedButtonText()
    const cancelButtonText = cancel_button_text ? cancel_button_text : 'Cancel'
    const prefix = dataTestIdPrefix ? `${dataTestIdPrefix}-` : 'confirmation-dialog-';

    return (
        <div className={`confirmation__dialog__container ${open ? 'open' : 'close'}`}
            onClick={(e) => e.stopPropagation()}
            data-testid={dataTestIdPrefix ? `${dataTestIdPrefix}-dialog` : "confirmation-dialog"}
        >
            <div className={`confirmation__dialog__center__container ${type}`}>
                <div className='confirmation__dialog__header'>
                    <div className='d-flex align-items-center gap-3'>
                        <DialougeSvg type={type} />
                        <span className='confirmation__dialog__title' data-testid={`${prefix}title`}>{title}</span>
                    </div>
                    <button className='close__button' onClick={onCancel} data-testid={`${prefix}close-btn`}>
                        <i className='fe fe-x color-text' />
                    </button>
                </div>
                <div className='confirmation__dialog__body' data-testid={`${prefix}description`}>{description}</div>
                <div className='confirmation__dialog__footer'>
                    <button className='cancel__button'
                        disabled={loading}
                        onClick={() => onDiscard ? onDiscard() : onCancel()}
                        data-testid={`${prefix}cancel-btn`}
                    >
                        {loading ? buttonText !== 'Discarding' ? cancelButtonText : buttonText : cancelButtonText}
                        {(loading && buttonText === 'Discarding') && <CircularProgress color='inherit' size={14} />}
                    </button>
                    <div className='d-flex align-items-center gap-2'>
                        <button className='save_closee__button'
                            disabled={loading}
                            onClick={() => onConfirm()}
                            data-testid={`${prefix}confirm-btn`}
                        >
                            {loading ? buttonText === 'Discarding' ? confirm_button_text : buttonText : confirm_button_text}
                            {(loading && buttonText !== 'Discarding') && <CircularProgress color='inherit' size={14} />}
                        </button>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationDialog